import { Box, Button, Modal, Stack, Typography, useTheme } from '@mui/material'
import React from 'react';
import { useState } from 'react';
import { useQueryClient } from 'react-query';
import { useAuthContext } from '../../../context/AuthContext';
import { customAlert, notify } from '../../../components/notify';
import { updateUsernameServ } from '../../../services/amtc-service';
import LabelTxtFieldInfo from '../../../components/LabelTxtFieldInfo';



function EditUsernameMdl({ modalOpen, handleModalClose, userData }) {
    const theme = useTheme();
    const [formErrors, setFormErrors] = useState({});
    const { setLoadingScreen } = useAuthContext();
    const queryClient = useQueryClient();



    async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
        let errorsObj = validate(inputObject);
        setFormErrors(errorsObj);
        if (Object.keys(errorsObj).length > 0)
            return;

        setLoadingScreen(true);
        try {
            const payload = {
                userId: userData?.userId,
                oldUsername: userData?.username,
                newUsername: inputObject?.newUsername,
                comId: userData?.comId
            }
            const { message } = await updateUsernameServ(payload);
            queryClient.invalidateQueries();
            notify("success", message);
            handleModalClose()
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    };

    function validate(values) {
        const errors = {};
        if (!values.newUsername)
            errors.newUsername = "Name is required!";
        return errors;
    };




    return (
        <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            {userData ? <form onSubmit={handleSubmit} >
                <Box sx={modalStyle}>
                    <Stack direction={'row'} alignItems={"center"} mb={2.5} mt={2}>
                        <Typography sx={{ fontWeight: "bold", fontSize: 17, color: "rgba(0, 0, 0, 0.6)", mr: 1 }}>Update Username</Typography>
                    </Stack>
                    <Stack gap={2} alignItems="center" mt={4}>
                        <LabelTxtFieldInfo defaultValue={userData?.username} errMsg={formErrors?.newUsername} name="newUsername" title="Email ID (Username) *" width={"100%"} borderRadius={1} />
                        <Stack justifyContent={"flex-end"} direction={"row"} sx={{ mt: 1 }} width={400} gap={2}>
                            <Button variant="text" sx={{ color: theme.palette.custom.btn, height: 30 }} onClick={handleModalClose}>CANCEL</Button>
                            <Button variant="contained" type='submit' sx={{ color: "white", bgcolor: theme.palette.custom.btn, height: 30 }}> SAVE</Button>
                        </Stack>
                    </Stack>
                </Box>
            </form> : <Typography component={'h1'}>Something went wrong</Typography>}
        </Modal>
    )
}

export default EditUsernameMdl;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #ffff',
    boxShadow: 24,
    px: 3,
    py: 2,
    borderRadius: 2,
    height: "43%"
};